import { h } from 'preact';
import { useState } from 'preact/hooks';
import { useSearchProvider } from '../search/useSearchProvider';
import { FilterPanel } from '../components/filters/FilterPanel';
import { SortDropdown } from '../components/sorting/SortDropdown';
import { Layout } from '../components/layout/Layout';
import { InfiniteScroll, LoadMoreButton } from '../components/infinite-scroll/InfiniteScroll';
export function UrbanSalesPage() {
    const [layout, setLayout] = useState('grid');
    const [isFilterPanelOpen, setIsFilterPanelOpen] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const pathname = window.location.pathname;
    const shouldUseSearchBar = pathname.includes('search');
    const { products, filters, sortOptions, loading, query, currentSort, handleQuerySubmit, handleFilterChange, handleSortChange, handlePageChange, meta, resetFilters, onRemoveFilter, } = useSearchProvider();
    const handleToggleLayout = () => {
        setLayout((l) => (l === 'grid' ? 'list' : 'grid'));
    };
    const handleFilterToggle = () => {
        setIsFilterPanelOpen(!isFilterPanelOpen);
    };
    const getCurrentPageFromUrl = () => {
        const urlParams = new URLSearchParams(window.location.search);
        return parseInt(urlParams.get('page') || '1', 10);
    };
    const handleLoadMore = () => {
        const currentUrlPage = getCurrentPageFromUrl();
        handlePageChange(currentUrlPage + 1);
    };
    const hasMore = (meta === null || meta === void 0 ? void 0 : meta.totalResults)
        ? products.length < meta.totalResults
        : false;
    const loadMoreButton = (h(LoadMoreButton, { products: products, totalProducts: meta === null || meta === void 0 ? void 0 : meta.totalResults, onLoadMore: handleLoadMore, disabled: loading }));
    return (h("div", null,
        shouldUseSearchBar ? (h("h1", { className: "h2 text-center", style: { paddingTop: '36px' } }, "Search")) : null,
        h(Layout, { layout: layout, onToggleLayout: handleToggleLayout, loadMoreButton: loadMoreButton, loading: loading, showSidebar: products.length > 0 || loading, sidebar: h(FilterPanel, { filters: filters, loading: loading, onFilterChange: handleFilterChange, onResetToCollection: resetFilters, isOpen: isFilterPanelOpen, onClose: () => setIsFilterPanelOpen(false), sortOptions: sortOptions, onSortChange: handleSortChange, totalProductCount: meta === null || meta === void 0 ? void 0 : meta.totalResults, currentSort: currentSort }), main: h("div", null,
                h("div", { className: "products-header" },
                    h(SortDropdown, { options: sortOptions, onChange: handleSortChange, totalProductCount: meta === null || meta === void 0 ? void 0 : meta.totalResults, currentSort: currentSort })),
                h(InfiniteScroll, { products: products, loading: loading, layout: layout, mode: "button", onFilterToggle: handleFilterToggle, filters: filters, totalProducts: meta === null || meta === void 0 ? void 0 : meta.totalResults, currentPage: currentPage, onPageChange: handlePageChange, onRemoveFilter: onRemoveFilter, onResetFilters: resetFilters, onRemoveAllFilters: resetFilters, hasMore: hasMore })) })));
}
